import styled from 'styled-components'

import colors from './colors'

const Button = styled.button`
  background: ${colors.red};
  background: ${colors.blue};
  border: none;
  padding: .66rem 1rem;
  color: white;
  font-weight: 500;
  font-size: 1rem;
  border-radius: .5rem;
  display: inline-block;
  opacity: .95;
  cursor: pointer;
  transition: all .2s ease;
  margin: 0 0 .5rem;
  outline: none;
  
  &:hover {
    opacity: 1;
  }
`
const ButtonNote = styled.div`
  color: ${colors.secondaryText};
  font-size: .9rem;
`
const ActionButton = styled.div`
  /* background: ${p => p.green ? colors.lightGreen : colors.lightOrange}; */
  color: ${p => p.green ? colors.green : colors.orange};
  cursor: pointer;
  opacity: .8;
  transition: all .2s ease;
  padding: .25rem .5rem;
  border-radius: 100px;
  display: inline-block;

  &:hover {
    opacity: 1;
  }

  ion-icon {
    font-size: 1rem;
  }
`
const ActionButtonLabel = styled.span`
  display: inline-block;
  margin: 0 0 0 .3rem;
  font-weight: 500;
`
const PhoneActionButton = styled.a`
  background: ${p => p.disabled ? 'transparent' : p.blue ? colors.lightBlue : colors.lightGreen};
  color: ${p => p.disabled ? colors.tertiaryText : p.blue ? colors.blue : colors.green};
  cursor: ${p => p.disabled ? 'auto' : 'pointer'};
  opacity: ${p => p.disabled ? 1 : .8};
  transition: all .2s ease;
  border-radius: 100px;
  display: inline-block;
  margin: 0 0 0 .75rem;
  width: 3rem;
  height: 3rem;

  &:hover {
    opacity: 1;
  }

  ion-icon {
    font-size: 1.5rem;
    margin: .75rem;
  }
`

export {
  Button,
  ButtonNote,
  ActionButton,
  ActionButtonLabel,
  PhoneActionButton,
}



// WEBPACK FOOTER //
// ./src/styles/buttons.js